import React from 'react'
import { useDefaultAgTechDataAction } from '@agtech/core/data/actions/AgTechDataActions';
import AgTechFormDialog from '@agtech/web/components/Portals/Dialogs/AgTechFormDialog';
import LogoUpdateForm from '../forms/OperationLogoUpdateForm';
import { AgTechQueryBuilder } from '@agtech/core/data/queries/AgTechDataQueries';
import { AgTechClickEventHandler, AgTechButtonProps, AgTechButton } from '@agtech/web/components/Buttons/AgTechButtons';

const OperationLogoUpdateDialog = () => {
    let action = useDefaultAgTechDataAction('Name');

    return (
        <AgTechFormDialog
            width={600}
            structure={() => ({
                header: 'Update operation logo'
            })}
            dialogData={{
                query: AgTechQueryBuilder.buildQueryResult({
                    data: {}
                }),
                getDialogData: d => d
            }}
            dialogAction={{
                action: action,
                getActionData: d => d
            }}
        >
            {() => <LogoUpdateForm />}
        </AgTechFormDialog>
    )
}

OperationLogoUpdateDialog.Open = (e: AgTechClickEventHandler) => e.dialogs.openDialog({
    dialog: () => <OperationLogoUpdateDialog />
});

OperationLogoUpdateDialog.Button = (props: AgTechButtonProps) => (
    <AgTechButton
        text={'Update Operation Logo'}
        icon='fas fa-upload'
        {...props}
        action={OperationLogoUpdateDialog.Open}
    />
)

export default OperationLogoUpdateDialog